import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-landing-page',
  templateUrl: './new-landing-page.component.html',
  styleUrls: ['./new-landing-page.component.scss']
})
export class NewLandingPageComponent implements OnInit {

  showMerchantModal = false;

  constructor() { }

  openMerchantModal() {
    this.showMerchantModal = true;
    document.body.style.overflow = 'hidden';
  }

  ngOnInit(): void {
  }

}
